import React from "react";

import TreeScreen from "./TreeScreen";

export default function PacketsScreen(props) {
  return <TreeScreen {...props} treeRoot="packets" editable={true} />;
}
